import React from 'react';
import { Chart } from 'primereact/chart';
import { chartOptions } from '../options/chartOptions';
import { getSeriesColor } from '../options/palette';


export default function LeaderboardChart({ data, sports }) {
  const datasets = sports.map((sport, i) => ({
    label: sport.name,
    backgroundColor: getSeriesColor(i),
    data: data.map(p => p.points[sport.name] ?? 0),
    stack: 'stack1',
  }));

  const chartData = {
    labels: data.map(p => p.name),
    datasets,
  };
  

  return (
    <div >
      <Chart type="bar" data={chartData} options={chartOptions()} style={{ marginBottom: "15px", height: "375px" }}/>
    </div>
  );
}

